var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.message && !_vm.is_closed)?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"notification m-1",class:_vm.notification_class,staticStyle:{"z-index":"0"}},[_c('button',{staticClass:"delete",on:{"click":_vm.close}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }